import type { DevicePorts } from '@Domain/Ports/DevicePorts';
import * as React from 'react';

const PortsContext = React.createContext<DevicePorts | null>(null);

export default PortsContext;
